import '@babel/polyfill';
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import lodash from 'lodash';
import VueLodash from 'vue-lodash';
import App from './App.vue';
import Router from './router';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faDownload, faArrowLeft, faUser, faTimes, faChevronLeft, faEllipsisV, faInfoCircle, faExclamationTriangle, faPlus, faAngleUp, faAngleDown, faQuestionCircle, faSearch, faCopy, faCircle, faFileExcel, faSignOutAlt} from '@fortawesome/free-solid-svg-icons';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { store } from './store';
import { Settings as LocaleSettings } from 'luxon';
import SiteStyles from './Assets/css/site.css';
import Paginate from 'vuejs-paginate';
import 'mime-types';
import VueRecaptcha from 'vue-recaptcha';
import jQuery from 'jquery';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import VueXlsx from 'vue-js-xlsx'
import VCalendar from 'v-calendar/lib/v-calendar.umd.min'
import { msalInstance } from './msalConfig';

LocaleSettings.defaultLocale = 'lt';

//console.log('VUE_APP_TITLE', process.env.VUE_APP_TITLE);
//console.log('VUE_APP_BASE_URL', process.env.VUE_APP_BASE_URL);

library.add(faDownload, faArrowLeft, faQuestionCircle, faUser, faTimes, faCalendar, faChevronLeft, faEllipsisV, faInfoCircle, faExclamationTriangle, faPlus, faAngleDown, faAngleUp, faSearch, faCopy, faCircle, faFileExcel, faSignOutAlt);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('vue-recaptcha', VueRecaptcha);
Vue.use(BootstrapVue);
Vue.use(Datetime);
Vue.use(SiteStyles);
// Vue.use(VueLodash, { name: 'lodash' });
Vue.use(VueLodash, { name: '$_ld', lodash: lodash });
Vue.use(VueCompositionAPI);
Vue.use(VueXlsx)
Vue.use(VCalendar)

Vue.component('paginate', Paginate);

window.$ = window.jQuery = jQuery; //require('jquery');


msalInstance.handleRedirectPromise()
  .then((response) => {
    if (response && response.account) {
      console.log("Prisijungta:", response.account);
      // console.log("Access Token:", response.accessToken);
      // console.log("Token galiojimo pabaiga:", response.expiresOn);
      localStorage.setItem('token', response.accessToken);
      localStorage.setItem('tokenExpires', new Date(response.expiresOn).toISOString());
      msalInstance.setActiveAccount(response.account);
      window.location.href = process.env.VUE_APP_BASE_URL;
    } else {
      const currentAccounts = msalInstance.getAllAccounts();
      if (currentAccounts.length > 0) {
        msalInstance.setActiveAccount(currentAccounts[0]);
      } else {
        console.log("Vartotojas neprisijungęs");
      }
    }
  })
  .catch((error) => {
    console.error("MSAL klaida:", error);
  });

// Vue.prototype.$msal = msalInstance;


new Vue({
   render: h => h(App),
   el: '#app',
   store,
   template: '',
   components: { App },
   router: Router,
   SiteStyles,
});
